import { Divider, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
    Control,
    FieldErrors,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue,
} from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import { callAPI, dateFormat, IsSmallScreen, Method } from "../../../../commonFunctions/CommonFunctions";
import WSMultiAutoComplete from "../../../../Components/AutoComplete/WSMultiAutocomplete";
import WSButton from "../../../../Components/Button/WSButton";
import WSSCheckBoxField from "../../../../Components/CheckBox/WSCheckBox";
import WSDateTimeField from "../../../../Components/DateField/WSDateTimePicker";
import WSHiddenField from "../../../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../../../Components/Select/WSSelect";
import WSTextField from "../../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../../Components/WSTextArea/WSTextArea";
import WSTimePicker from "../../../../Components/WSTimePicker/WSTimePicker";
import config from "../../../../Config/clientConfig.json";
import { AppState } from "../../../../StateManagement/types";
import { useParams } from "react-router-dom";

interface TaskProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    meetingId?: string;
    setValue: UseFormSetValue<any>;
    onCancel: () => void
}



const MeetingDrawyer: React.FC<TaskProps> = ({
    control, id, register, meetingId, reset, setValue, onCancel
}) => {
    const [activityDate, setActivityDate] = useState<any>(undefined);
    const [isReminder, setIsReminder] = useState(false);
    const [dealsData, setDealsData] = useState<any>([])
    const [particpants, setparticpants] = useState<any>([])
    const isMobile = IsSmallScreen()
    const param= useParams();
    const leadId=param?.id
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    //  deals/{leadId}/lead
    const source = {
        url: "auth/search",
        page: 1,
        pageSize: 10000000,
        filter: [],
        sort: [],
    };
    useEffect(() => {

        const getDeals = async () => {
            try {
                const response: any = await callAPI(`deals/${leadId}/lead`, Method.GET, null, null);
                if (Array.isArray(response)) {
                    const updatedDeals = response.map((item: any) => ({
                        value: item.id,
                        label: item.dealName
                    }));


                    setDealsData(updatedDeals || []);
                }
            }

            catch (e) {

            }
        }
        if (leadId) {
            getDeals();
        }
    }, [leadId])
    useEffect(() => {

        const getMeetings = async () => {
            try {
                const response: any = await callAPI(`meetings`, Method.GET, null, meetingId);

                setValue('title', response?.title)
                setValue('startDateTime', dateFormat(response?.startDateTime, 'DD-MM-YYYY HH:mm:ss'))
                setValue('endDateTime', dateFormat(response?.endDateTime, 'DD-MM-YYYY HH:mm:ss'))
                setValue('meetingType', response?.meetingType)
                setValue('dealId', response?.dealId)
                setValue('notes', response?.notes)
                //  setValue('participantIds',response?.participantIds)
                setparticpants(response?.participantIds)
                setValue('reminderOption', response?.reminderOption)
                setValue('customReminderTime', response?.customReminderTime)
                setValue('reminderSent', response?.reminderSent)
            }

            catch (e) {

            }
        }
        if (meetingId) {
            getMeetings();
        }
    }, [meetingId])
    const handleActivityChange = (evt: any) => {

        if (evt.target.value !== 'custom') {
            let date = dayjs();
            const val = evt.target.value === 1 ? 0 : evt.target.value === 2 ? 1 : evt.target.value
            date = date.add(Number(val), 'days'); // Assuming value is number of days
            setActivityDate(date.toISOString()); // Converts to ISO 8601 format
        } else {

            setActivityDate(evt.target.value);
        }
    };
    const handleIsReminderSend = (evt: any) => {
        setIsReminder(evt?.target?.checked)
    }
    const transFormData = (data: any) => {

        const users: Array<any> = []
        data.map((item: any) => {
            users.push({ value: item.id, label: `${item.firstName} ${item.lastName || ""}` })
        })
        return users
    }
    const reduxComponentData = useSelector(
        (state: AppState) => state.components["meetingSubmit"],
        shallowEqual
    );

    // Local state to store Redux data
    const [componentData, setComponentData] = useState(reduxComponentData);

    // Update useState when Redux state changes
    useEffect(() => {
        if (reduxComponentData) {
            setComponentData(reduxComponentData);
        }
    }, [reduxComponentData]);
    return (
        <Grid >
            {
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12}>
                        <Typography fontWeight={"bold"} sx={{ fontSize: '.9rem' }}>Meeting Information</Typography>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <WSTextField
                            label={"Title"}
                            {...register("title")}
                            id="title"
                            name="title"
                            control={control}
                            rules={{ required: true }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSDateTimeField
                            label={"Start Date"}
                            // disabled={activityDate !== 'custom'}
                            id="startDateTime"
                            //  defaultValue={dateFormat(activityDate, "DD-MM-YYYY")}
                            setValue={setValue}
                            name="startDateTime"
                            control={control}
                            viewClock={false}
                            rules={{ required: true }}

                        />
                        {/* <WSDateField
                            dateFormat={"DD-MM-YYYY"}
                            label={"Start Date"}
                            //  disabled={activityDate !== 'custom'}
                            id="startDateTime"
                            // defaultValue={dateFormat(activityDate, "DD-MM-YYYY")}
                            setValue={setValue}
                            name="startDateTime"
                            control={control}
                            rules={{ required: true }}

                        /> */}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSDateTimeField
                            label={"End Date"}
                            // disabled={activityDate !== 'custom'}
                            id="endDateTime"
                            //  defaultValue={dateFormat(activityDate, "DD-MM-YYYY")}
                            setValue={setValue}
                            name="endDateTime"
                            control={control}
                            viewClock={false}
                            rules={{ required: true }}

                        />
                        {/* <WSDateField
                            dateFormat={"DD-MM-YYYY"}
                            label={"End Date"}
                            // disabled={activityDate !== 'custom'}
                            id="endDateTime"
                            //defaultValue={dateFormat(activityDate, "DD-MM-YYYY")}
                            setValue={setValue}
                            name="endDateTime"
                            control={control}
                            rules={{ required: true }}

                        /> */}
                    </Grid>



                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            options={config.taskTypeSourceConfig.staticOptionData}
                            rules={{ required: true }}
                            {...register("meetingType")}
                            id="meetingType"
                            isMobile={isMobile}
                            control={control}
                            defaultValue={"0"}
                            label="Meeting type"
                            name="meetingType"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            options={dealsData}
                            rules={{ required: true }}
                            {...register("dealId")}
                            id="dealId"
                            isMobile={isMobile}
                            control={control}
                            defaultValue={0}
                            label="Deal"
                            name="dealId"
                        />
                    </Grid>


                    <Grid item xs={12} sm={12}>
                        <WSTextAreaField
                            label={"Notes"}
                            {...register("notes")}
                            id="notes"
                            name="notes"
                            control={control}
                            rules={{ required: true }}
                            rows={2}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <WSMultiAutoComplete
                            source={source}
                            rules={{ required: true }}
                            transFormData={transFormData}
                            {...register("participantIds")}
                            // id="participantIds"
                            setValue={setValue}
                            multiple={true}
                            // isMobile={isMobile}
                            control={control}
                            defaultValue={particpants}
                            label="Participants"
                            name="participantIds"
                        />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <WSSCheckBoxField
                            label="Reminder Send"
                            id="reminderSent"
                            control={control}
                            {...register("reminderSent")}
                            rules={{ required: false }}
                            name="reminderSent"

                            onChange={handleIsReminderSend}
                        />

                        <WSHiddenField control={control} name="meetingId" defaultValue={meetingId} />
                    </Grid>

                    {isReminder && <><Grid item xs={12} sm={6}>
                        <WSTimePicker
                            id="customReminderTime"
                            name="customReminderTime"
                            label={"Reminder Time"}
                            control={control}
                            setValue={setValue}
                            rules={{ required: true }}
                        />
                    </Grid>
                        <Grid item xs={12} sm={6}>
                            <WSSelectField
                                options={config.reminderSourceConfig.staticOptionData}
                                rules={{ required: true }}
                                {...register("reminderOption")}
                                id="reminderOption"
                                isMobile={isMobile}
                                control={control}
                                defaultValue={0}
                                label="Reminder"
                                name="reminderOption"
                            />
                        </Grid></>}

                    <Grid item xs={12} sm={12}>
                        <Divider />
                    </Grid>
                    <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton className="ws-theme-crm" variant="outlined" id='meetingSubmit' label={"Save"} type="submit" size="medium" loading={reduxComponentData?.data?.loading} />
                        </Grid>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                        </Grid>
                    </Grid>
                </Grid >

            }
        </Grid >
    );
};
export default MeetingDrawyer;
